/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkActionJobStatusResponse } from '../models/BulkActionJobStatusResponse';
import type { BulkActionSubmitRequest } from '../models/BulkActionSubmitRequest';
import type { BulkActionSubmitResponse } from '../models/BulkActionSubmitResponse';
import type { BulkActionTargetsResponse } from '../models/BulkActionTargetsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminBulkActionsService {
    /**
     * Submit Bulk Action
     * Enqueue a bulk action over a filter-selected set of contacts.
     * @param requestBody
     * @returns BulkActionSubmitResponse Successful Response
     * @throws ApiError
     */
    public static submitBulkActionApiAdminBulkActionsPost(
        requestBody: BulkActionSubmitRequest,
    ): CancelablePromise<BulkActionSubmitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/bulk-actions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bulk Action
     * Status summary for one job (counts, timestamps, error).
     * @param jobId
     * @returns BulkActionJobStatusResponse Successful Response
     * @throws ApiError
     */
    public static getBulkActionApiAdminBulkActionsJobIdGet(
        jobId: string,
    ): CancelablePromise<BulkActionJobStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/bulk-actions/{job_id}',
            path: {
                'job_id': jobId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bulk Action Targets
     * Paginated per-contact results — pass ``status=failed`` to list failures.
     * @param jobId
     * @param status Filter by target status (pending/done/failed)
     * @param limit
     * @param offset
     * @returns BulkActionTargetsResponse Successful Response
     * @throws ApiError
     */
    public static getBulkActionTargetsApiAdminBulkActionsJobIdTargetsGet(
        jobId: string,
        status?: (string | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BulkActionTargetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/bulk-actions/{job_id}/targets',
            path: {
                'job_id': jobId,
            },
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Bulk Action
     * Enqueue a bulk action over a filter-selected set of contacts.
     * @param requestBody
     * @returns BulkActionSubmitResponse Successful Response
     * @throws ApiError
     */
    public static submitBulkActionAdminBulkActionsPost(
        requestBody: BulkActionSubmitRequest,
    ): CancelablePromise<BulkActionSubmitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/bulk-actions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bulk Action
     * Status summary for one job (counts, timestamps, error).
     * @param jobId
     * @returns BulkActionJobStatusResponse Successful Response
     * @throws ApiError
     */
    public static getBulkActionAdminBulkActionsJobIdGet(
        jobId: string,
    ): CancelablePromise<BulkActionJobStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/bulk-actions/{job_id}',
            path: {
                'job_id': jobId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bulk Action Targets
     * Paginated per-contact results — pass ``status=failed`` to list failures.
     * @param jobId
     * @param status Filter by target status (pending/done/failed)
     * @param limit
     * @param offset
     * @returns BulkActionTargetsResponse Successful Response
     * @throws ApiError
     */
    public static getBulkActionTargetsAdminBulkActionsJobIdTargetsGet(
        jobId: string,
        status?: (string | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BulkActionTargetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/bulk-actions/{job_id}/targets',
            path: {
                'job_id': jobId,
            },
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
